import React, { useState, useEffect } from 'react';

import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  Paper,
  useTheme,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditSource = () => {
   const theme = useTheme(); 
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [SourceName, setSourceName] = useState('');
  const { SourceId } = useParams();
  const navigate = useNavigate();

  // Static Source data
  const staticSourceData = [
    { SourceId: 1, SourceName: 'Ex-Customer' },
    { SourceId: 2, SourceName: 'Facebook' },
    { SourceId: 3, SourceName: 'Field Campaign' },
    { SourceId: 4, SourceName: 'LinkedIn' },
    { SourceId: 5, SourceName: 'Phone Cell' },
    { SourceId: 6, SourceName: 'Referral' },
    { SourceId: 7, SourceName: 'SMS Enquiry' },
    { SourceId: 8, SourceName: 'Instagram' },
  ];

  useEffect(() => {
    // Find the Source to edit based on SourceId
    const Source = staticSourceData.find(
      Source => Source.SourceId === parseInt(SourceId)
    );
    if (Source) {
      setSourceName(Source.SourceName);
    } else {
      alert('Source not found');
    }
  }, [SourceId]);

  const handleUpdate = () => {
    if (SourceName) {
      console.log('Updated Source:', SourceName);
      setShowSuccessModal(true);
    } else {
      alert('Please enter a Source name');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Source
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
      <TextField
  label="Source Name"
  variant="outlined"
  fullWidth
  value={SourceName}
  onChange={(e) => setSourceName(e.target.value)}
  InputLabelProps={{
    shrink: true,
  }}
  sx={{
    mb: 3,

    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },

    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
  }}
/>
<Tooltip title={!SourceName ? "Enter Source Name" : ""} arrow>            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!SourceName}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Source Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Source Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditSource;